import { setZP, setUser } from "@/utils/user.utils";
import types from '@/constants/types';
import links from '@/constants/links';
import { now, toDate, diff } from '@/utils/date.utils';

export default {
    [types.UPDATE_USER]({ commit }, { user = null }) {
        const currentUser = user ? { user } : null
        setUser(currentUser);

        commit(types.UPDATE_USER, user)
    },
    [types.UPDATE_ZP]({ commit }, payload = {}) {
        setZP(payload.points);

        commit(types.UPDATE_ZP, payload)
    },
    [types.UPDATE_USER_RESTRICTIONS]({ commit }, payload) {
        commit(types.UPDATE_USER_RESTRICTIONS, payload)
    },
    [types.UPDATE_CONFIG]({ commit }, payload) {
        commit(types.UPDATE_CONFIG, payload)
    },
    [types.UPDATE_TOTAL_IN_GAME_ONLINE]({ commit }, payload) {
        commit(types.UPDATE_TOTAL_IN_GAME_ONLINE, payload)
    },
    [types.UPDATE_NOTIFICATIONS]: async({ commit, dispatch, getters }, payload) => {
        let newNotifications = payload.notifications;

        if (typeof payload.notifications === 'object') {
            newNotifications = payload.notifications.map((notification) => {
                const end = now();
                const start = toDate(notification.created_at || now());
                const isTimeValid = diff(start, end).minutes() <= 1;
                const newNotification = {
                    message: notification.message || '',
                    ...(notification.data || {}),
                    id: notification.id || (getters.lastNotificationId + 1),
                    read_at: notification.read_at || null,
                    created_at: notification.created_at || start.toDate(),
                    type: notification.type || 'GENERAL_NOTIFICATION',
                    icon: notification.icon || 'info-circle',
                    timeout: notification.timeout || 5000,
                    iconColor: notification.iconColor || 'accent',
                    color: notification.color || 'primary',
                    canShow: !notification.read_at && isTimeValid
                }

                if (notification.route && notification.route.link && (notification.route.link.includes('http') ||
                notification.route.link.includes('https') ||
                notification.route.link.includes('www.'))) {
                    newNotification.navigateTo = {
                        href: notification.route.link,
                        target: '_blank'
                    }
                } else {
                    newNotification.navigateTo = {
                        to: (notification.route || {}).link || links.routes.welcome,
                    }
                }

                return newNotification;
            })

            const lastId = (newNotifications[newNotifications.length - 1] || {}).id || 1;

            if (typeof lastId === 'number') {
                await dispatch(types.SET_LAST_NOTIFICATION_ID, lastId)
            }
        }

        commit(types.UPDATE_NOTIFICATIONS, {
            notifications: newNotifications
        })
    },
    [types.SET_LAST_NOTIFICATION_ID]: async({ commit }, lastId) => {
        commit(types.SET_LAST_NOTIFICATION_ID, lastId);
    },
    [types.HIDE_COMPONENT_VISIBILITY]: async({ commit }, payload) => {
        commit(types.HIDE_COMPONENT_VISIBILITY, payload);
    },
    [types.UPDATE_COMPONENT_VISIBILITY]: async({ commit, dispatch, getters }, payload = null) => {
        if (payload === null) {
            await dispatch(types.HIDE_COMPONENT_VISIBILITY);
        }
        if (Object.keys(getters.getComponentVisibility).filter((key) => Object.keys(payload).includes(key)).length > 0){
            await dispatch(types.HIDE_COMPONENT_VISIBILITY);
        }


        commit(types.UPDATE_COMPONENT_VISIBILITY, payload);
    }
}
